module.exports = {
      id: "thodargal-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#thodargal",
      toString: function () {
        return this.url;
      }
    }